
class ImageGridLightbox {
    constructor() {
        this.modal = document.getElementById('imageLightbox');
        this.images = [];
        this.currentIndex = 0;
        this.init();
    }

    init() {
        this.collectImages();
        this.bindEvents();
    }

    collectImages() {
        const imageItems = document.querySelectorAll('.image-wrapper');
        this.images = Array.from(imageItems).map(item => ({
        src: item.dataset.imageSrc,
        alt: item.dataset.imageAlt,
        index: parseInt(item.dataset.imageIndex)
        }));
    }

    bindEvents() {
        // Open lightbox on image click
        document.querySelectorAll('.image-wrapper').forEach((wrapper, index) => {
        wrapper.addEventListener('click', () => this.openLightbox(index));
        });

        // Close lightbox
        this.modal.querySelector('.lightbox-close').addEventListener('click', () => this.closeLightbox());
        this.modal.querySelector('.lightbox-overlay').addEventListener('click', () => this.closeLightbox());

        // Navigation
        this.modal.querySelector('.lightbox-prev').addEventListener('click', () => this.previousImage());
        this.modal.querySelector('.lightbox-next').addEventListener('click', () => this.nextImage());

        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
        if (!this.modal.classList.contains('active')) return;
        
        switch(e.key) {
            case 'Escape':
            this.closeLightbox();
            break;
            case 'ArrowLeft':
            this.previousImage();
            break;
            case 'ArrowRight':
            this.nextImage();
            break;
        }
        });
    }

    openLightbox(index) {
        this.currentIndex = index;
        this.updateImage();
        this.modal.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    closeLightbox() {
        this.modal.classList.remove('active');
        document.body.style.overflow = '';
    }

    updateImage() {
        const image = this.modal.querySelector('.lightbox-image');
        const loading = this.modal.querySelector('.lightbox-loading');
        const currentImage = this.images[this.currentIndex];

        loading.style.display = 'block';
        image.style.display = 'none';

        const img = new Image();
        img.onload = () => {
        image.src = currentImage.src;
        image.alt = currentImage.alt;
        image.style.display = 'block';
        loading.style.display = 'none';
        };
        img.src = currentImage.src;
    }

    previousImage() {
        this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.images.length - 1;
        this.updateImage();
    }

    nextImage() {
        this.currentIndex = this.currentIndex < this.images.length - 1 ? this.currentIndex + 1 : 0;
        this.updateImage();
    }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new ImageGridLightbox();
});